import { parseCellId } from '@cards/engine';
import { cardRef, defineGameCard, ongoing } from '../authoring/index.js';
const DINING_TABLE_ID = 'dining_table';
export const DiningTableCard = defineGameCard({
    id: DINING_TABLE_ID,
    gameplay: { type: 'STRUCTURE', cost: 2, baseStats: { attack: 0, health: 5 } },
    presentation: {
        name: 'Обеденный стол',
        description: 'Постоянно: другие ваши карты в этой локации получают +1 к атаке.',
        glyph: {
            colors: ['#10213A', '#61371F', '#A16236', '#864D28', '#864D28'],
            rows: [
                '....................',
                '....................',
                '....................',
                '....................',
                '....................',
                '.111111111111111111.',
                '12333333333333333321',
                '12444444444444444441',
                '.114411111111112211.',
                '..1421........1241..',
                '..1421........1241..',
                '..1421........1241..',
                '..1421........1241..',
                '..1421........1241..',
                '..1421........1241..',
                '...11..........11...',
                '....................',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef(DINING_TABLE_ID)],
    abilities: [
        ongoing((ctx) => {
            const self = ctx.self;
            if (self?.cellId === undefined)
                return [];
            const tableId = parseCellId(self.cellId).tableId;
            return ctx.q.unitsOf(self.controllerId)
                .filter((unit) => unit.id !== self.id
                && unit.cellId !== undefined
                && parseCellId(unit.cellId).tableId === tableId)
                .map((unit) => ({
                abilityId: `allied_cards:${unit.id}`,
                scope: { kind: 'unit', instanceId: unit.id },
                statMods: [{ stat: 'attack', op: 'add', value: 1 }],
            }));
        }),
    ],
    ui: { mechanics: ['ongoing'] },
});
//# sourceMappingURL=dining_table.js.map